<template>
    <div>
        <div>
            <div class="md:grid md:grid-cols-6 md:gap-6">
                <div class="sm:col-span-1">
                    <label class="block text-sm font-medium leading-5 text-gray-700">
                        {{ $t('messages.display_as') }}
                    </label>
                    <div class="mt-1">
                        <div
                            class="inline-flex items-center"
                            v-for="displayOption in displayOptions"
                            :key="displayOption.value"
                        >
                            <input
                                name="display_option"
                                :id="`display_option_${displayOption.value}`"
                                :value="displayOption.value"
                                v-model="show"
                                type="radio"
                                class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                            />
                            <label class="ml-1 mr-3" :for="`display_option_${displayOption.value}`">
                                <span class="block text-sm leading-5 font-medium text-gray-700">
                                    {{ displayOption.name }}
                                </span>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="sm:col-span-1">
                    <label class="block text-sm font-medium leading-5 text-gray-700">
                        {{ $tc('messages.colours', 2) }}
                    </label>
                    <div class="mt-1">
                        <div class="inline-flex items-center">
                            <label>
                                <input
                                    type="checkbox"
                                    name="colors"
                                    v-model="displayColors"
                                    class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                />
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <table class="mt-5 min-w-full divide-y divide-gray-200">
            <thead>
                <tr>
                    <td>{{ $t('messages.name') }}</td>
                    <td class="text-center" v-for="dimension in dimensions" :key="dimension.abbreviation">
                        {{ dimension.abbreviation }}
                    </td>
                    <td class="text-center">{{ $t('messages.global') }}</td>
                    <td class="text-center">
                        {{ $tc('messages.attendance') }}
                    </td>
                    <td class="text-center">
                        {{ $tc('messages.activities', 2) }}
                    </td>
                    <td>{{ $t('messages.other') }}</td>
                </tr>
            </thead>
            <tbody>
                <tr
                    :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                    v-for="(student, index) in students"
                    :key="student.student_id"
                >
                    <td>
                        <a :href="student.student_show_url">
                            {{ student.student }}
                        </a>
                    </td>
                    <td
                        class="text-center"
                        :class="displayColors ? dimension['bg-color'] : ''"
                        v-for="(dimension, dimensionIndex) in student.dimensions"
                        :key="dimensionIndex"
                    >
                        <template v-if="show === 'score'">
                            {{ dimension.grade_display }}
                        </template>
                        <template v-else>
                            {{ dimension.letter }}
                        </template>
                    </td>
                    <td class="text-center" :class="displayColors ? student.global['bg-color'] : ''">
                        <span v-if="show === 'score'" :title="student.global.letter">
                            {{ student.global.grade_display }}
                        </span>
                        <span v-else :title="student.global.grade_display">
                            {{ student.global.letter }}
                        </span>
                    </td>
                    <td class="text-center">{{ student.attendance }}</td>
                    <td class="text-center">
                        {{ student.activities.number }} / {{ student.activities.total }} ({{
                            (student.activities.percent * 100).toFixed(2)
                        }}%)
                    </td>
                    <td>{{ student.explanation }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    name: 'DimensionGradesTable',
    props: ['dimensions', 'students'],
    data() {
        return {
            displayColors: true,
            show: 'letter',
            displayOptions: [
                { name: this.$tc('messages.scores', 2), value: 'score' },
                { name: this.$tc('messages.letters', 2), value: 'letter' },
            ],
        };
    },
};
</script>
